export const CHANGE_BRIGHTNESS="change_brightness";
export const CHANGE_SATURATE="change_saturate";
export const CHANGE_CONTRAST="change_contrast";
export const CHANGE_SEPIA="change_sepia";
export const CHANGE_DARKNESS="change_darkness";


export const EDIT_STATUS="edit_status";

export const CHANGE_TEXT="change_text";